module.exports = __webpack_public_path__ + "img/Kucing&Jongkok.276b51b0.svg";